const storageKey = giftId => `cdo-order-attempt:${giftId}`;

export const getOrderRequestKey = giftId => {
  const stored = sessionStorage.getItem(storageKey(giftId));
  if (stored) {
    if (!/^[\da-f]{32}$/.test(stored)) throw new Error('Invalid order attempt');
    return stored;
  }
  const bytes = window.crypto.getRandomValues(new Uint8Array(16));
  const key = [...bytes].map(byte => byte.toString(16).padStart(2, '0')).join('');
  // Persist BEFORE sending. If storage is unavailable, do not risk an unrepeatable order.
  sessionStorage.setItem(storageKey(giftId), key);
  return key;
};

export const clearOrderRequestKey = giftId => {
  try {
    sessionStorage.removeItem(storageKey(giftId));
  } catch {
    // A confirmed order stays confirmed even if storage later becomes unavailable.
  }
};
